/* -------------------------------------------------------------------------------------------------
Restricted - Copyright (C) Siemens Healthcare GmbH/Siemens Medical Solutions USA, Inc., 2020. All rights reserved
------------------------------------------------------------------------------------------------- */
import { dispatchAttributeChangedEvent } from './attribute-changed-event-dispatcher.js';

export const CheckboxToggleMixin = (superClass) =>
  class extends superClass {
    static get properties() {
      return {
        active: { type: Boolean, reflect: true },
        neutral: { type: Boolean, reflect: true },
      };
    }

    updated(changedProperties) {
      super.updated(changedProperties);
      const listOfProperties = ['active', 'neutral'];
      dispatchAttributeChangedEvent(this, changedProperties, listOfProperties);
    }
    firstUpdated() {
      super.firstUpdated();
      this.addEventListener('click', () => this.handleClick());
      this.addEventListener('focus', () => this.handleFocus());
      this.addEventListener('blur', () => this.handleBlur());
    }
    handleClick() {
      this.active = !this.active;
    }
  };
